module.exports = __webpack_public_path__ + "img/vipIcon.44ef1b3d.png";